import React from 'react';
import { Field, FieldProps, FormikHandlers } from 'formik';
import { InputBase } from '@brighterion/br-ui';

type Props = {
    id?: string;
    name: string;
    label: string;
    handleChange: FormikHandlers['handleChange'];
    handleBlur: FormikHandlers['handleBlur'];
    className?: string;
};

export const FieldId = ({ className, id, name, label, handleChange, handleBlur }: Props) => {
    return (
        <Field name={name}>
            {({ field, form: { errors, touched } }: FieldProps) => {
                return (
                    <InputBase
                        className={className}
                        id={id ?? name}
                        label={label}
                        value={field.value ?? ''}
                        name={name}
                        error={!!(errors[field.name] && touched[field.name])}
                        errorMsg={errors[field.name]?.toString()}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        size='sm'
                        maxLength={128}
                        data-testid='add-merchant-id-field'
                        allowPan
                        panErrorMsg=''
                    />
                );
            }}
        </Field>
    );
};

export default FieldId;
